// @react-lib/hooks/useI18n.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { useCallback } from 'react';
import { observer } from 'mobx-react-lite';
import { i18nStore, type Locale, type TranslationKey, type TranslationParams } from '@core/stores';

/**
 * Hook for internationalization
 * Provides access to i18n store and translation function
 */
export function useI18n() {
  const store = i18nStore;

  /**
   * Translate a key with optional parameters
   */
  const t = useCallback(
    (key: TranslationKey, params?: TranslationParams): string => {
      return store.t(key, params);
    },
    [store]
  );

  /**
   * Change the current locale
   */
  const setLocale = useCallback(
    async (locale: Locale): Promise<void> => {
      await store.setLocale(locale);
    },
    [store]
  );

  return {
    // Current locale
    locale: store.locale,
    // Supported locales
    supportedLocales: store.supportedLocales,
    // Loading state
    isLoading: store.isLoading,
    // Initialization state
    isInitialized: store.isInitialized,
    // Translation function
    t,
    // Set locale
    setLocale,
    // Check if translation exists
    has: store.has.bind(store),
  };
}

/**
 * HOC to make a component observe i18n changes
 */
export function withI18n<P extends object>(
  Component: React.ComponentType<P>
): React.ComponentType<P> {
  return observer(Component as React.FunctionComponent<P>) as unknown as React.ComponentType<P>;
}

export type { Locale, TranslationKey, TranslationParams };
